__turbopack_context__.v({
  "className": "peyda_352d6311-module__H3UC6W__className",
  "variable": "peyda_352d6311-module__H3UC6W__variable",
});
